import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineAnchorIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 13h-2a1.0001 1.0001 0 0 0 0 2h.91a5.9995 5.9995 0 0 1-1.6726 3.2374A5.9995 5.9995 0 0 1 13 19.91V11h1a1.0001 1.0001 0 0 0 0-2h-1V7.82a2.9996 2.9996 0 0 0 1.9568-3.3357A3.0004 3.0004 0 0 0 12 1.9916a3.0002 3.0002 0 0 0-2.5876 4.518A3 3 0 0 0 11 7.82V9h-1a1 1 0 0 0 0 2h1v8.91A5.9997 5.9997 0 0 1 6.09 15H7a1.0002 1.0002 0 0 0 .7071-1.7071A1.0002 1.0002 0 0 0 7 13H5a1.0002 1.0002 0 0 0-1 1 8.0001 8.0001 0 0 0 13.6569 5.6569A8.0005 8.0005 0 0 0 20 14a1.0001 1.0001 0 0 0-1-1Zm-7-7a1.0001 1.0001 0 1 1 0-2.0002A1.0001 1.0001 0 0 1 12 6Z"/>
  </SvgIcon>
}

export default LineAnchorIcon
